module.exports = __webpack_public_path__ + "static/sara-51aa74d687a505fe9289429419063398.jpg";